<script>
import Modal from '../../components/Modal.vue'
import { debounce } from 'lodash'
import VueSelect from 'vue-select'

export default {
    components: {
        Modal,
        VueSelect,
    },

    props: {
        users: {
            type: Array,
            required: true
        },
        requisitions: {
            type: Array,
            required: true
        },
        jobs: {
            type: Array,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        }
    },

    computed: {
        requisition() {
            return this.selectedRequisition.title;
        },
        filteredRequisitions() {
            if (this.requisitions) {
                return this.requisitions.map(requisition => {
                    return {
                        id: requisition.id,
                        title: requisition.person_specification.title
                    }
                });
            }
            return [];
        },
        filteredJobs() {
            if (this.jobs) {
                return this.jobs.map(job => {
                    return {
                        id: job.id,
                        title: job.title,
                        requisition_id: job.requisition_id
                    };
                });
            }
            return [];
        }
    },

    data() {
        return {
            selectedRequisition: null,
            selectedRequisitionData: null,
            results: [],
            showResult: false,
            requisitionJobs: []
        }
    },

    methods: {
        fetchRequisitionJobs(search = '', loading = null) {
            if (loading) loading(true);
            this.search(`/recruiter/active-requisitions/index.json?search=${search}&limit=1000&status=active`, loading, json => {
                this.requisitionJobs = json.requisitions;
                for (let i = 0; i < this.requisitionJobs.length; i++) {
                    if (this.requisitionJobs[i].job !== null) {
                        this.requisitionJobs[i].title = this.requisitionJobs[i].job.title;
                    } else {
                        this.requisitionJobs[i].title = this.requisitionJobs[i].display_name;
                    }
                }
            });
        },
        search: debounce((url, loading, mapResult) => {
            fetch(url).then(res => {
                res.json().then(mapResult);
                if (loading) loading(false);
            });
        }, 250),
        toggleModal() {
            this.$refs.modal.toggle();
            this.showResult = false
        },
        moveToRequisition() {
            // Prepare the data to be sent in the POST request
            const postData = {
                selectedRequisitionData: this.selectedRequisitionData,
                users: this.users
            };

            // Perform the POST request
            this.showResult = false
            fetch('/recruiter/active-requisitions/move-to-requisition', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': this.csrfToken
                },
                body: JSON.stringify(postData)
            })
                .then(response => response.json())
                .then(data => {
                    this.results = data
                    this.showResult = true
                })
                .catch(error => {
                    // Handle the error
                    // ...
                });
        },
    },
    mounted() {
        this.showResult = false;
        this.fetchRequisitionJobs();
    }
}
</script>

<template>
    <modal ref="modal" heading="Move To Requisition" :timesButton="false">
        <form @submit.prevent="moveToRequisition" v-if="!showResult">
            <input type="hidden" name="_csrfToken" :value="csrfToken" />

            <div class="mb-4">
                <label>Choose Job Ads</label>
                <vue-select label="title"
                            @search="fetchRequisitionJobs"
                            :options="requisitionJobs"
                            v-model="selectedRequisitionData"
                >
                    <template slot="option" slot-scope="option">
                        {{ option.job !== null ? option.job.title : option.display_name }} (#{{ option.id }}, {{ option.person_specification.business_line.company.title }})
                    </template>
                </vue-select>
            </div>

            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button class="button primary" type="submit">Move</button>
                </div>

                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </form>
        <div v-else>
            <div class="mb-4">
                <h4>Result</h4>
                <ul>
                    <li v-for="(result, index) in results" :key="index">{{ result }}</li>
                </ul>
            </div>
            <div class="grid-x grid-padding-x align-right">
                <div class="cell shrink">
                    <button @click="toggleModal" class="button warning" type="button">Close</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<style>
.select-box {
    height: 50px;
    border-radius: 2px;
}
</style>
